import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import React from "react";
import { useNavigate } from "react-router-dom";
import Fonts from "../../Config/Fonts";
import Colors from "../../theme/Colors";

const BreadcrumbsComponent = ({ breadcrumbs }) => {
  const navigate = useNavigate();
  const handleClick = (href) => () => {
    navigate(href);
  };

  return (
    <Stack spacing={3}>
      <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{ marginLeft: '2%', marginTop: "16px" }}
      >
        {breadcrumbs?.map(({ key, href, text }) => (
          <Link
            underline="hover"
            key={key}
            color="inherit"
            style={{
              fontSize: 16,
              fontWeight: "500",
              fontFamily: Fonts.Poppins,
              color: Colors.breadCrumbsColor,
            }}
            onClick={handleClick(href)}
          >
            {text}
          </Link>
        ))}
      </Breadcrumbs>
    </Stack>
  );
};

export default BreadcrumbsComponent;
